const TimeDisplay = (data) => {
  const firstValue = Object.values(data)[0];
  const firstItem = Object.values(firstValue)[0];
  const dataExtracao = firstItem[0].data_extracao;
  if (dataExtracao) {
    const date = new Date(dataExtracao);

    const timeString = date.toLocaleTimeString();
    const dateString = date.toLocaleDateString();
    return `${dateString} - ${timeString}`;
  } else {
    return "";
  }
};

export default TimeDisplay;
